import React from "react";
import { motion } from "framer-motion";
import { BookOpenIcon, GiftIcon, GlobeIcon, FlameIcon, LockIcon, InfinityIcon, ZapIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { images } from "../../data/content";
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function Offer() {
  const filled = (TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100;
  return <section id="offer" className="bg-brand-950 px-4 py-16 md:py-24" aria-labelledby="offer-title" data-id="element-177" data-mp="3a3clg2ubprnr">
      <div className="mx-auto max-w-2xl" data-id="element-178" data-mp="3f2ffks8rmdgy">
        <div className="text-center" data-id="element-179" data-mp="3juqhg0n2g9c5">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-gold" data-id="element-180" data-mp="3jvs2mxxsqc7l">Special launch offer</p>
          <h2 id="offer-title" className="mt-3 text-balance font-serif text-[1.9rem] font-black leading-tight text-white sm:text-4xl md:text-5xl" data-id="element-181" data-mp="3nw27g79uqwkv">
            Here's everything you'll receive today
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white" data-id="element-182" data-mp="1klglokytmeke">
          <img src={images.mockup} alt="Everything included in the Sensory Decision Map™" className="w-full" loading="lazy" data-id="element-183" data-mp="1kmrpulw6hoc1" />

          <div className="px-5 pb-7 pt-2 sm:px-8" data-id="element-184" data-mp="1foq3ns3gh8wc">
            <ul className="divide-y divide-sand" data-id="element-185" data-mp="1bll4nzil3pcg">
              <li className="flex items-center justify-between gap-4 py-4" data-id="element-186" data-mp="16lp284pjc5z0">
                <span className="flex items-center gap-3" data-id="element-187" data-mp="16ns1lfckvbge">
                  <BookOpenIcon className="h-6 w-6 shrink-0 text-brand-600" aria-hidden="true" data-id="element-188" data-mp="23awml9ef491c" />
                  <span data-id="element-189" data-mp="1zbfhih2wldwp">
                    <span className="block font-bold text-ink" data-id="element-190" data-mp="1zaw7dmjhvtt8">Sensory Decision Map™</span>
                    <span className="text-sm text-muted" data-id="element-191" data-mp="1ui35r7jbp1ld">6 Premium Volumes</span>
                  </span>
                </span>
                <s className="shrink-0 font-semibold text-muted" data-id="element-192" data-mp="1pigpep87758c">$97</s>
              </li>
              <li className="flex items-center justify-between gap-4 py-4" data-id="element-193" data-mp="2n19wb46s9cjl">
                <span className="flex items-center gap-3" data-id="element-194" data-mp="2i8gq0bvo1w5e">
                  <GiftIcon className="h-6 w-6 shrink-0 text-brand-600" aria-hidden="true" data-id="element-195" data-mp="315qu3s6klmz7" />
                  <span data-id="element-196" data-mp="364ali83xnqyy">
                    <span className="block font-bold text-ink" data-id="element-197" data-mp="364tuv0fip71d">5 Professional Bonuses</span>
                    <span className="text-sm text-muted" data-id="element-198" data-mp="2sdyru4rp9k5p">Intake, Organizer, Glossary, Challenges, Tracker</span>
                  </span>
                </span>
                <s className="shrink-0 font-semibold text-muted" data-id="element-199" data-mp="2wce9ru8xc2c9">$147</s>
              </li>
              <li className="flex items-center justify-between gap-4 py-4" data-id="element-200" data-mp="2ih2ffnyokdvv">
                <span className="font-bold uppercase tracking-wide text-ink" data-id="element-201" data-mp="2nfngtqpo53lw">Total value</span>
                <s className="shrink-0 text-lg font-bold text-stop" data-id="element-202" data-mp="29fme05pufm3s">USD $244</s>
              </li>
            </ul>

            <div className="mt-4 rounded-2xl bg-brand-50 px-5 py-6 text-center" data-id="element-203" data-mp="2dg6e9i5pr5u5">
              <p className="text-[15px] font-semibold text-muted" data-id="element-204" data-mp="7o9clqn33wch">But you don't need to pay $244. Today only:</p>
              <p className="mt-1 font-serif font-black leading-none text-brand-900" data-id="element-205" data-mp="bnqk0pm2n3ka">
                <span className="align-top text-2xl" data-id="element-206" data-mp="1w7dkufxrd78n">USD $</span>
                <span className="text-[5.5rem] md:text-[6.5rem]" data-id="element-207" data-mp="1s5ijjbftutuv">27</span>
              </p>
              <p className="mt-2 text-sm font-semibold text-brand-700" data-id="element-208" data-mp="25w3umdz1hzi7">One-time payment · No monthly subscription</p>
            </div>

            <div className="mt-6" data-id="element-209" data-mp="214viha6bs01c">
              <CtaButton label="Get the Sensory Decision Map™" data-id="element-210" data-mp="213killg03cfi" />
            </div>

            <div className="mt-4 flex items-start gap-2.5 rounded-xl bg-go-light px-4 py-3 text-left" data-id="element-211" data-mp="2fsqd4w3w8eh2">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-go-deep" aria-hidden="true" data-id="element-212" data-mp="2av7182uo4dsa" />
              <p className="text-sm leading-snug text-ink" data-id="element-213" data-mp="2ougf2vveivt3">
                <strong data-id="element-214" data-mp="2jvwt4vgt5k0q">Automatic currency conversion:</strong> the price is shown in USD and is automatically converted to
                your local currency at checkout.
              </p>
            </div>

            <div className="mt-6" data-id="element-215" data-mp="pj6yucmj28st">
              <div className="flex items-center justify-between gap-3" data-id="element-216" data-mp="pk89ifzmsta0">
                <p className="flex items-center gap-1.5 text-sm font-extrabold text-stop" data-id="element-217" data-mp="rw0q1kt860ol">
                  <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-218" data-mp="vxcjk1f7z622" />
                  Only {SPOTS_LEFT} spots left at the promo price!
                </p>
                <p className="text-sm font-bold text-ink" data-id="element-219" data-mp="15wjsmcex8ejd">{Math.round(filled)}%</p>
              </div>
              <div className="mt-2 h-4 overflow-hidden rounded-full bg-stop-light" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-220" data-mp="88tc1o3zuxb1">
                <motion.div className="h-full rounded-full bg-stop" initial={{
                width: "8%"
              }} whileInView={{
                width: `${filled}%`
              }} viewport={{
                once: true
              }} transition={{
                duration: 1.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-221" data-mp="mxz50uc8nrah" />
              </div>
              <p className="mt-2 text-xs text-muted" data-id="element-222" data-mp="3j2i280odbpfm">
                {TOTAL_SPOTS - SPOTS_LEFT} of {TOTAL_SPOTS} promotional spots already claimed. When they run out, the price goes up.
              </p>
            </div>

            <div className="text-ink" data-id="element-223" data-mp="3460vjmr4iyze">
              <Countdown data-id="element-224" data-mp="344z7mhp0ei09" />
            </div>

            <ul className="mt-7 grid grid-cols-2 gap-3 text-sm font-semibold text-ink" data-id="element-225" data-mp="3483ly7w6uu4n">
              {[{
              icon: ZapIcon,
              label: "Instant delivery"
            }, {
              icon: InfinityIcon,
              label: "Lifetime access"
            }, {
              icon: LockIcon,
              label: "Secure checkout"
            }, {
              icon: ShieldCheckIcon,
              label: "7-Day Guarantee"
            }].map(({
              icon: Icon,
              label
            }) => <li key={label} className="flex items-center gap-2" data-id="element-226" data-mp="2ggeuetr6y9or">
                  <Icon className="h-4 w-4 shrink-0 text-go" aria-hidden="true" data-id="element-227" data-mp="2gfmy1gprs7xf" />
                  {label}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mx-auto mt-8 max-w-xl text-center text-[15px] leading-relaxed text-brand-100" data-id="element-228" data-mp="21s68ejkowp85">
          For less than the cost of many professional reference materials, you'll have a complete visual reasoning system you
          can return to whenever a case feels difficult to organize.
        </p>
      </div>
    </section>;
}